import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import Alert from '../components/ui/Alert';
import config from '../config';
import './SubscriptionPage.css'; // Reuse the same CSS

const SubscriptionSuccessPage = () => {
  const { user, markUserSubscriptionActive, loading } = useAuth();
  const navigate = useNavigate();

  // Mark subscription as active when component mounts
  useEffect(() => {
    if (user?.id) {
      // Store email in localStorage for future use
      if (user.email) {
        localStorage.setItem('userEmail', user.email);
      }
      
      markUserSubscriptionActive(user.id);
      
      // Set a timeout to redirect to dashboard after 5 seconds
      const timeoutId = setTimeout(() => {
        navigate('/dashboard');
      }, 5000);
      
      return () => clearTimeout(timeoutId);
    }
  }, [user, markUserSubscriptionActive, navigate]);

  // Show loading state
  if (loading) {
    return (
      <div className="subscription-page">
        <div className="container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-page">
      <div className="container">
        <div className="subscription-header">
          <h1 className="page-title">Subscription Successful!</h1>
          <p className="page-subtitle">
            Thank you for subscribing to {config.stripe.productName}
          </p>
        </div>

        <div className="subscription-content">
          <Card className="subscription-card active-subscription">
            <div className="subscription-card-header">
              <h2>Subscription Activated</h2>
              <div className="subscription-badge">Active</div>
            </div>
            
            <div className="subscription-card-content">
              <Alert 
                type="success"
                title="Success"
                message="Your subscription has been successfully activated. You now have full access to all features."
                className="mb-md"
              />
              
              <p>
                You now have full access to all features of {config.stripe.productName}.
                You will be redirected to your dashboard in a few seconds.
              </p>
              
              <div className="subscription-features">
                <h3>Your Benefits</h3>
                <ul>
                  {config.subscription.features.map((feature, index) => (
                    <li key={index} className="feature-active">
                      <span className="feature-check">✓</span> {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            <div className="subscription-card-footer">
              <Link to="/dashboard">
                <Button>
                  Go to Dashboard
                </Button>
              </Link>
              
              <Link to="/subscription">
                <Button variant="secondary">
                  Manage Subscription
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccessPage;
